import { render, staticRenderFns } from "./WorkflowModal.vue?vue&type=template&id=e961ab24&"
import script from "./WorkflowModal.vue?vue&type=script&lang=js&"
export * from "./WorkflowModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports